"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = remoteConfigStatus;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
function remoteConfigStatus(props) {
  const {
    appName,
    appVersion,
    maintenanceData,
    refreshAppData,
    refreshAppSpecificData
  } = props;
  const isNewerVersion = (v1, v2) => {
    const parts1 = v1.split('-');
    const parts2 = v2.split('-');
    if (Number(parts1[0]) > Number(parts2[0])) {
      return true;
    }
    return Number(parts1[1]) > Number(parts2[1]);
  };
  function hasMaintenance() {
    const jsonData = JSON.parse(maintenanceData);
    return jsonData.enabled && jsonData.apps.includes(appName);
  }
  function hasRefreshApp() {
    const jsonData = JSON.parse(refreshAppData);
    return jsonData.shouldRefresh && jsonData.apps.includes(appName) && !isNewerVersion(appVersion, jsonData.olderThan);
  }
  function hasRefreshAppSpecific() {
    const jsonData = JSON.parse(refreshAppSpecificData);
    return jsonData.shouldRefresh && jsonData.apps.includes(appName) && jsonData.versions.some(v => appVersion.includes(v));
  }
  if (hasMaintenance()) {
    return {
      status: 'maintenance',
      info: ''
    };
  }
  if (hasRefreshApp(appVersion)) {
    return {
      status: 'refresh',
      info: JSON.parse(refreshAppData).info
    };
  }
  if (hasRefreshAppSpecific(appVersion)) {
    return {
      status: 'refresh',
      info: JSON.parse(refreshAppSpecificData).info
    };
  }
  return {
    status: 'none',
    info: ''
  };
}